import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { $profile } from '@/entities/profile-entity';
import { PageScroll } from '@/layouts/page-layout';
import { useUnit } from 'effector-react';
import { AtSignIcon, CalendarIcon, ShieldIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import ProfileStatsSection from './profile-stats-section';

const formatter = buildFormatter(russianStrings);

const ROLE_LABEL: Record<string, string> = {
	worker: 'Worker',
	carder: 'Carder',
	admin: 'Admin',
};

export default function ProfilePage() {
	const profile = useUnit($profile);

	if (!profile) {
		return null;
	}

	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-4'>
			<div className='flex flex-col gap-4'>
				<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
					<CardHeader className='border-b px-4 py-4'>
						<div className='flex items-center gap-3'>
							<div className='rounded-lg bg-muted/60 p-2'>
								<AtSignIcon size={20} />
							</div>
							<div>
								<CardTitle>#{profile.nickname}</CardTitle>
								<CardDescription>{ROLE_LABEL[profile.role] ?? profile.role}</CardDescription>
							</div>
						</div>
					</CardHeader>
					<CardContent className='px-4 py-4 flex flex-col gap-3'>
						<div className='flex items-center gap-2 text-sm'>
							<ShieldIcon size={16} className='opacity-50' />
							<span className='text-muted-foreground'>Роль</span>
							<span className='ml-auto font-medium'>{ROLE_LABEL[profile.role] ?? profile.role}</span>
						</div>
						<div className='flex items-center gap-2 text-sm'>
							<CalendarIcon size={16} className='opacity-50' />
							<span className='text-muted-foreground'>Регистрация</span>
							<span className='ml-auto font-medium'>
								<TimeAgo date={profile.createdAt} formatter={formatter} />
							</span>
						</div>
					</CardContent>
				</Card>

				<ProfileStatsSection />
			</div>
		</PageScroll>
	);
}
